import { Helmet } from 'react-helmet-async';

// ── Placeholders — update these when ready ────────────────────────────────────
const SITE_NAME = 'Open Card Vault';
const SITE_URL  = 'https://opencardvault.com';        // TODO: replace with production URL
const OG_IMAGE  = '/og-image.png';                // TODO: replace with real OG image (1200×630)
const TWITTER_HANDLE = '@opencardvault';              // TODO: replace with real Twitter/X handle
// ─────────────────────────────────────────────────────────────────────────────

interface SEOProps {
  title?: string;          // page-level title; appended with " | Open Card Vault"
  description?: string;    // page-level description
  image?: string;          // absolute or root-relative image URL
  url?: string;            // root-relative path, e.g. "/marketplace"
  type?: 'website' | 'article' | 'product';
  noIndex?: boolean;       // true for protected/private pages
}

export default function SEO({
  title,
  description,
  image,
  url,
  type = 'website',
  noIndex = false,
}: SEOProps) {
  const fullTitle   = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const fullUrl     = url ? `${SITE_URL}${url}` : SITE_URL;
  const fullImage   = image
    ? (image.startsWith('http') ? image : `${SITE_URL}${image}`)
    : `${SITE_URL}${OG_IMAGE}`;
  const defaultDesc = 'Buy, sell, and trade Pokemon, Magic, Yu-Gi-Oh! and more. Join the ultimate marketplace for trading card collectors.';
  const metaDesc    = description || defaultDesc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type"        content={type} />
      <meta property="og:url"         content={fullUrl} />
      <meta property="og:image"       content={fullImage} />
      <meta property="og:site_name"   content={SITE_NAME} />

      {/* Twitter / X */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:site"        content={TWITTER_HANDLE} />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image"       content={fullImage} />

      {/* Canonical */}
      {url && <link rel="canonical" href={fullUrl} />}
    </Helmet>
  );
}
